module.exports = __webpack_public_path__ + "static/media/cxdo-logo.c7f6ded0.png";